import React from "react";

const UserInfoContext = React.createContext({
  divisions: {},
  divisionSeasons: {},
  franchises: {},
  leagues: {},
  leagueSeasons: {},
  teams: {},
  user: {},
});

export default UserInfoContext;
